<template>
  <v-container grid-list-xs class="pa-0">
    <v-layout row wrap>
      <v-flex xs12>
        <PC-Table
          name="Log History"
          :headers="headers"
          :items="logs"
          @edit="edit"
          @remove="remove"
        />
        <PC-Dialog
          type="Edit Log"
          :showDialog="showDialog"
          :fields="fields"
          @close="close"
          @save="save"
        >
          <template v-slot:button>
            <div></div>
          </template>
        </PC-Dialog>
      </v-flex>
    </v-layout>
    <AdView id="165" />
    <PCModal />
  </v-container>
</template>

<script>
import firebase from "@/firebase";
import AdView from "@/components/AdView";
import PCDialog from "@/components/PCDialog";
import PCModal from "@/components/PCModal";
import PCTable from "@/components/PCTable";
export default {
  components: { AdView, PCDialog, PCModal, PCTable },
  data() {
    return {
      editId: 1,
      fields: [
        {
          name: "Chemical",
          type: "text",
          value: "",
          classes: ["pa-2", "xs12"],
        },
        {
          name: "Amount",
          type: "text",
          value: "",
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "Units",
          type: "text",
          value: "",
          classes: ["pa-2", "xs12", "md6"],
        },
      ],
      headers: [
        { text: "Timestamp", align: "left", value: "timestamp" },
        { text: "Pool", align: "left", value: "pool" },
        { text: "Additions", align: "left", value: "additions" },
        { text: "Actions", align: "left", value: "actions" },
      ],
      logs: [],
      showDialog: false,
    };
  },
  computed: {
    logsRef() {
      return firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("logs");
    },
  },
  methods: {
    close() {
      this.fields.forEach((field) => (field.value = ""));
      this.showDialog = false;
    },
    async edit(id) {
      this.editID = id;
      const log = await this.logsRef.doc(id).get();
      const data = log.data();
      this.fields[0].value = data.chemical;
      this.fields[1].value = data.amount;
      this.fields[2].value = data.units;
      this.showDialog = true;
    },
    async remove(id) {
      await this.logsRef.doc(id).delete();
      await this.updateLogs();
    },
    pushLog(log) {
      const data = log.data();
      this.logs.push({
        id: log.id,
        pool: data.pool,
        timestamp: new Date(data.timestamp),
        additions: `Added ${data.amount} ${data.units} of ${data.chemical}`,
      });
    },
    async save() {
      const data = {
        chemical: this.fields[0].value,
        amount: this.fields[1].value,
        units: this.fields[2].value,
      };
      await this.logsRef.doc(this.editID).update(data);
      await this.updateLogs();
      this.fields.forEach((field) => (field.value = ""));
      this.showDialog = false;
    },
    async updateLogs() {
      this.logs = [];
      const logs = await this.logsRef.get();
      logs.forEach((log) => this.pushLog(log));
      this.logs.sort((a, b) => {
        return b.timestamp - a.timestamp;
      });
    },
  },
  async mounted() {
    await this.updateLogs();
  },
};
</script>
